import React, { useMemo } from 'react';
import TableManager from '../components/data/TableManager';

// Configuration for SKE_Richieste columns based on actual DDL
const columnConfig = [
  // --- Keys and Identifiers ---
  "RIC_Id_Richieste=0,ID Richiesta,isPrimaryKey",
  "RIC_IdRif_Richieste=1,ID Rif. Richiesta,type=number",
  
  // --- Main Request Information ---
  "RIC_Id_Prodotti=2,Prodotto,lookupTable=SKE_Prodotti,lookupField=PRO_Nome,type=number,required",
  "RIC_DescrizioneRichiesta=2,Descrizione Richiesta,type=text,required",
  "RIC_Richiedente=2,Richiedente,type=text,required",
  "RIC_Id_TipiUrgenza=2,Tipo Urgenza,lookupTable=SKE_TipiUrgenza,lookupField=TIU_Descrizione,type=number",
  
  // --- Workflow Dates ---
  "RIC_CodiceDocumentale=1,Codice Documentale",
  "RIC_DataRichiesta=2,Data Richiesta,type=date",
  "RIC_DataPreventivo=1,Data Preventivo,type=date",
  "RIC_DataAccettazione=1,Data Accettazione,type=date",
  
  "RIC_DataPrevistaInizio=2,Data Prevista Inizio,type=date",
  "RIC_DataPrevistaFine=2,Data Prevista Fine,type=date",
  
  "RIC_DataInizio=1,Data Inizio,type=date",
  "RIC_DataFine=1,Data Fine,type=date",
 
  "RIC_DataConsegna=1,Data Consegna,type=date",
  // --- Additional Fields ---
  
  // --- Validity and Status ---
  "RIC_InizioValidita=0,Inizio Validità,type=date",
  "RIC_FineValidita=0,Fine Validità,type=date",
  "RIC_StatiRecord=0,Stato Record",
  
  // --- Audit Fields ---
  "RIC_UtenteInserimento=0,Utente Inserimento",
  "RIC_TerminaleInserimento=0,Terminale Inserimento",
  "RIC_DataOraInserimento=0,Data/Ora Inserimento,type=datetime",
  "RIC_UtenteModifica=0,Utente Modifica",
  "RIC_TerminaleModifica=0,Terminale Modifica",
  "RIC_DataOraModifica=0,Data/Ora Modifica,type=datetime",
  "RIC_Utente=0,Utente Audit",
  "RIC_Terminale=0,Terminale Audit",
  "RIC_Timestamp=0,Timestamp DB,type=datetime",
]; // CORRETTO: Parentesi quadra invece di parentesi graffa

// CORRETTO: Configuration for Form Layout - formato compatibile con NewRecordForm
const formLayoutConfig = {
  sections: [
    {
      title: "Informazioni Generali",
      fields: [
        "RIC_Id_Prodotti",
        "RIC_DescrizioneRichiesta", 
        "RIC_Richiedente"
      ]
    },
    {
      title: "Urgenza e Codice",
      fields: [
        "RIC_Id_TipiUrgenza",
        "RIC_CodiceDocumentale"
      ]
    },
    {
      title: "Date Workflow",
      // Usa layout grid diretto per 3 colonne
      fields: [
        ["RIC_DataRichiesta", "RIC_DataPreventivo", "RIC_DataAccettazione"]
      ]
    },
    {
      title: "Date Pianificate",
      layout: "twoColumns",
      columns: [
        {
          title: "Data Prevista Inizio",
          fields: ["RIC_DataPrevistaInizio"]
        },
        {
          title: "Data Prevista Fine", 
          fields: ["RIC_DataPrevistaFine"]
        }
      ]
    },
    {
      title: "Date Effettive",
      layout: "twoColumns",
      columns: [
        {
          title: "Data Inizio",
          fields: ["RIC_DataInizio"]
        },
        {
          title: "Data Fine",
          fields: ["RIC_DataFine"]
        }
      ]
    },
    {
      title: "Data Consegna",
      fields: [
        "RIC_DataConsegna"
      ]
    }
  ]
};

// Configuration for Filters
const filterConfig = [
  { field: 'RIC_Id_Prodotti', label: 'Prodotto', type: 'lookup', lookupName: 'prodottiLookup', lookupType: 'select' },
  { field: 'RIC_DescrizioneRichiesta', label: 'Descrizione', type: 'text' },
  { field: 'RIC_Richiedente', label: 'Richiedente', type: 'text' },
  { field: 'RIC_Id_TipiUrgenza', label: 'Tipo Urgenza', type: 'lookup', lookupName: 'tipiUrgenzaLookup', lookupType: 'select' },
  { field: 'RIC_DataRichiesta', label: 'Data Richiesta', type: 'date' },
  { field: 'RIC_DataPrevistaInizio', label: 'Data Prevista Inizio', type: 'date' },
  { field: 'RIC_DataPrevistaFine', label: 'Data Prevista Fine', type: 'date' },
];

// Configuration for Lookups
const lookupConfig = {
  RIC_Id_Prodotti: {      // ✅ Usa il nome del campo
    tableName: 'SKE_Prodotti',
    valueField: 'PRO_Id_Prodotti',
    labelField: 'PRO_CodiceProdotto',
  },
  RIC_Id_TipiUrgenza: {   // ✅ Usa il nome del campo
    tableName: 'DOM_TipiUrgenza',
    valueField: 'TIU_Id_TipiUrgenza',
    labelField: 'TIU_Descrizione',
  },
  // Mantieni anche quelli originali se servono per i filtri
  prodottiLookup: {
    tableName: 'SKE_Prodotti',
    valueField: 'PRO_Id_Prodotti',
    labelField: 'PRO_CodiceProdotto',
  },
  tipiUrgenzaLookup: {
    tableName: 'DOM_TipiUrgenza',
    valueField: 'TIU_Id_TipiUrgenza',
    labelField: 'TIU_Descrizione',
  },
};

// Specific Input Types for Form Fields - All date fields now use 'date' type
const inputTypes = {
  RIC_DescrizioneRichiesta: 'textarea',
  RIC_Richiedente: 'text',
  RIC_Id_Prodotti: 'select',
  RIC_Id_TipiUrgenza: 'select',
  RIC_DataRichiesta: 'date',
  RIC_DataPreventivo: 'date',
  RIC_DataAccettazione: 'date',
  RIC_DataConsegna: 'date',
  RIC_DataPrevistaInizio: 'date',
  RIC_DataInizio: 'date',
  RIC_DataPrevistaFine: 'date',
  RIC_DataFine: 'date',
  RIC_CodiceDocumentale: 'text',
  RIC_InizioValidita: 'date',
  RIC_FineValidita: 'date',
  RIC_IdRif_Richieste: 'number',
  RIC_Utente: 'number',
};

const RichiestePage = () => {
  // ✅ NUOVO: Valori di default per la creazione
  const defaultValuesForCreate = useMemo(() => {
    const today = new Date().toISOString().split('T')[0]; // Formato YYYY-MM-DD
    return {
      RIC_DataRichiesta: today,     // Data richiesta = oggi
      RIC_Id_TipiUrgenza: 1,        // Tipo urgenza = 1 (default)
    };
  }, []);

  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">
        Gestione Richieste
      </h1>

      <TableManager
        tableName="SKE_Richieste"
        primaryKey="RIC_Id_Richieste"
        pageTitle="Gestione Richieste"
        columnConfig={columnConfig}
        formLayoutConfig={formLayoutConfig}
        filterConfig={filterConfig}
        lookupConfig={lookupConfig}
        inputTypes={inputTypes}
        enableCreate={true}
        enableEdit={true}
        enableDelete={true}
        defaultSortField="RIC_DataRichiesta"
        defaultSortDirection="desc"
        statusField="RIC_Id_TipiUrgenza" // ✅ Campo per colorazione righe
        defaultValuesForCreate={defaultValuesForCreate} // ✅ Valori di default
      />
    </div>
  );
};

export default RichiestePage;